import { c as _c } from "react/compiler-runtime";
import { DataFileInterface } from '@systemeio/file-manager';
import { DangerButton, SuccessButton } from '@systemeio/ui';
import MobileVariantsTable from 'modules/products/components/Variants/mobile-variants-table';
import Variant from 'modules/products/components/Variants/variant';
import { ProductVariantInterface, ProductVariantsErrorsInterface } from 'modules/products/types/product-variant-interface';
import { getFilteredVariantsImagesList } from 'modules/products/utils/product-variants-utils';
import { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import useWindowSize from 'shared/hooks/use-window-size';
import { twMerge } from 'tailwind-merge';
import { ulid } from 'ulid';
interface VariantsProps {
  allowStock?: boolean;
  stock: number;
  variants: ProductVariantInterface[];
  setVariants: React.Dispatch<React.SetStateAction<ProductVariantInterface[]>>;
  errors: ProductVariantsErrorsInterface;
  setErrors: React.Dispatch<React.SetStateAction<ProductVariantsErrorsInterface>>;
}
function Variants(t0) {
  const $ = _c(42);
  const {
    allowStock,
    stock,
    variants,
    setVariants,
    errors,
    setErrors
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [selectedVariants, setSelectedVariants] = useState(t1);
  const [isDeleteAvailable, setIsDeleteAvailable] = useState(true);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [variantsImages, setVariantsImages] = useState(t2);
  const {
    t
  } = useLocoTranslation();
  useWindowSize();
  const {
    isLG
  } = useMediaQuery();
  let t3;
  if ($[2] !== selectedVariants || $[3] !== setVariants) {
    t3 = () => {
      setVariants(prev => prev.map(v => selectedVariants.includes(v) ? {
        ...v,
        deleted: true,
        selected: false
      } : v));
    };
    $[2] = selectedVariants;
    $[3] = setVariants;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleMarkVariantAsDeleted = t3;
  let t4;
  if ($[5] !== selectedVariants || $[6] !== setVariants) {
    t4 = () => {
      setVariants(prev_0 => prev_0.map(v_0 => selectedVariants.includes(v_0) ? {
        ...v_0,
        id: ulid(),
        deleted: false,
        selected: false
      } : v_0));
    };
    $[5] = selectedVariants;
    $[6] = setVariants;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleUnmarkVariantAsDeleted = t4;
  let t5;
  let t6;
  if ($[8] !== variants) {
    t5 = () => {
      const filteredSelectedVariants = variants.filter(_temp);
      if (filteredSelectedVariants.length === 1) {
        if (filteredSelectedVariants[0]?.deleted) {
          setIsDeleteAvailable(false);
        } else {
          setIsDeleteAvailable(true);
        }
      }
      setVariantsImages(getFilteredVariantsImagesList(variants));
      setSelectedVariants(filteredSelectedVariants);
    };
    t6 = [variants];
    $[8] = variants;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== allowStock || $[12] !== setVariants || $[13] !== stock) {
    t7 = () => {
      if (allowStock && stock > 0) {
        setVariants(prev_1 => prev_1.map(v_1 => ({
          ...v_1,
          stock: v_1.stock ?? stock
        })));
      }
    };
    $[11] = allowStock;
    $[12] = setVariants;
    $[13] = stock;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== allowStock || $[16] !== stock) {
    t8 = [stock, allowStock];
    $[15] = allowStock;
    $[16] = stock;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  useEffect(t7, t8);
  let t9;
  if ($[18] !== allowStock || $[19] !== variants) {
    t9 = allowStock || variants?.some(_temp2);
    $[18] = allowStock;
    $[19] = variants;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const hasStock = t9;
  let t10;
  if ($[21] !== handleMarkVariantAsDeleted || $[22] !== handleUnmarkVariantAsDeleted || $[23] !== isDeleteAvailable || $[24] !== selectedVariants.length || $[25] !== t) {
    t10 = !!selectedVariants.length && <div className="my-2 inline-flex text-base"><div className="text-text-primary self-center">{t("dashboard.products.variants.selected.title", {
          count: selectedVariants.length
        })}</div>{isDeleteAvailable ? <DangerButton onClick={handleMarkVariantAsDeleted} className="ml-2 !py-0">{t("dashboard.products.delete_variants.title", {
          count: selectedVariants.length
        })}</DangerButton> : <SuccessButton onClick={handleUnmarkVariantAsDeleted} className="ml-2 !py-0">{t("dashboard.products.restore_variants.title", {
          count: selectedVariants.length
        })}</SuccessButton>}</div>;
    $[21] = handleMarkVariantAsDeleted;
    $[22] = handleUnmarkVariantAsDeleted;
    $[23] = isDeleteAvailable;
    $[24] = selectedVariants.length;
    $[25] = t;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== allowStock || $[28] !== errors || $[29] !== hasStock || $[30] !== isDeleteAvailable || $[31] !== isLG || $[32] !== selectedVariants.length || $[33] !== setErrors || $[34] !== setVariants || $[35] !== t || $[36] !== variants || $[37] !== variantsImages) {
    t11 = !isLG ? <MobileVariantsTable variants={variants} setVariants={setVariants} isDeleteAvailable={!!selectedVariants.length ? isDeleteAvailable : null} variantsImages={variantsImages} /> : <div className="grid"><div className={twMerge("grid justify-items-center", hasStock ? "grid-cols-[18px_56px_minmax(15%,30%)_minmax(10%,18%)_minmax(10%,18%)_minmax(10%,20%)] gap-2" : "grid-cols-[25px_70px_minmax(15%,45%)_minmax(10%,20%)_minmax(10%,20%)] gap-5")}><div className="col-start-3 justify-self-start">{t("dashboard.products.variant.title")}</div><div className="col-start-4 justify-self-center">{t("dashboard.products.sku.title")}</div><div className="col-start-5 justify-self-center">{t("global.price")}</div>{hasStock && <div className="col-start-6 justify-self-center">{t("dashboard.products.stock.header")}</div>}</div><hr className="border-t-1 border-text-secondary mb-2 mt-2 border-solid lg:-mx-6 lg:-mr-6" />{variants.map(variant_0 => <Variant allowStock={allowStock} key={variant_0.id} variant={variant_0} setVariants={setVariants} isDeleteAvailable={!!selectedVariants.length ? isDeleteAvailable : null} variantsImages={variantsImages} errors={errors[variant_0.id] ?? {
        sku: "",
        stock: "",
        price: ""
      }} setErrors={setErrors} />)}</div>;
    $[27] = allowStock;
    $[28] = errors;
    $[29] = hasStock;
    $[30] = isDeleteAvailable;
    $[31] = isLG;
    $[32] = selectedVariants.length;
    $[33] = setErrors;
    $[34] = setVariants;
    $[35] = t;
    $[36] = variants;
    $[37] = variantsImages;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t10 || $[40] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  return t12;
}
function _temp2(v_2) {
  return v_2.stock && v_2.stock > 0;
}
function _temp(variant) {
  return variant.selected;
}
export default Variants;